import { DialogContent, DialogContentText, Typography } from '@mui/material';
import ModalCustom from 'components/Modal/Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { closeDialogAction } from 'store/actions/dialogsActions';
import { useAppState } from 'store/Provider';
import useManagementService from '../services/useManagementService';

type ManagementDuplicationDialogProps = {
  isFromTM: boolean;
};

const ManagementDuplicationDialog: React.FC<ManagementDuplicationDialogProps> = ({ isFromTM }) => {
  const { state, dispatch } = useAppState();
  const { dialogs } = state;
  const isOpen = dialogs.managementDuplicationDialog;
  const { activeOrderId } = state.management;
  const { duplicateOrder } = useManagementService();
  const [t] = useTranslation();

  const message = isFromTM ? t('Duplicate_TM_Order_Confirmation_Text') : t('Duplicate_Quote_Confirmation_Text');

  const dialogBody = (
    <DialogContent>
      <DialogContentText>
        <Typography component="span">{message}</Typography>
      </DialogContentText>
    </DialogContent>
  );
  return (
    <ModalCustom
      open={isOpen}
      modalName="managementDuplicationDialog"
      onClose={() => dispatch(closeDialogAction('managementDuplicationDialog'))}
      onConfirm={() => duplicateOrder(activeOrderId)}
      titleText={t('Duplicate_Quote')}
      confirmText={t('Duplicate')}
      cancelText={t('Dont_Copy')}
      body={dialogBody}
      size="md"
      confirmLoad
    />
  );
};

export default ManagementDuplicationDialog;
